






import { Component, Vue } from 'vue-property-decorator';
import DepartmentList from '@/components/Department/DepartmentList.vue';

@Component({
  components: {
    DepartmentList,
  },
})
export default class Departments extends Vue {}
